<ion-content>
  <div class="ion-padding ion-margin">
    <ion-item class="input-border" lines="none"> </ion-item>
    <div class="msg  ion-margin-bottom">
      <div class="font14 font600 content msg primary-text-center">
        {{ message }}
      </div>
    </div>
    <ion-button
      (click)="closeModal()"
      mode="ios"
      expand="block"
      class="primary-btn mart10"
    >
      {{ "modals.message_modal.ok" | translate }}
    </ion-button>
  </div>
</ion-content>
